module.exports = __webpack_public_path__ + "img/5.411095c4.png";